import TextField, {TextFieldProps} from '@material-ui/core/TextField/TextField'

const SearchInput = (props: TextFieldProps) => {
  return (
    <TextField className="search-input" {...props}/>
  )
}

export default SearchInput
